module.exports = __webpack_public_path__ + "img/my_location-hover.cc21ecb1.svg";